import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_BOT_DEPLOYMENTS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent deployments.'),
      403: i18n.t('You are not allowed to fetch agent deployments.'),
      404: i18n.t('The agent deployments you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the agent deployments.'),
      default: i18n.t('An error occurred fetching the agent deployments.')
    }
  },
  FETCH_BOT_DEPLOYMENT: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent deployment.'),
      403: i18n.t('You are not allowed to fetch agent deployment.'),
      404: i18n.t('The agent deployment you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the agent deployment.'),
      default: i18n.t('An error occurred fetching the agent deployment.')
    }
  },

  FETCH_BOT_DEPLOYMENT_PREVIEW: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent deployment preview.'),
      403: i18n.t('You are not allowed to fetch agent deployment preview.'),
      404: i18n.t('The agent deployment preview you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the agent deployment preview.'),
      default: i18n.t('An error occurred fetching the agent deployment preview.')
    }
  },
  CREATE_BOT_DEPLOYMENT: {
    ERROR: {
      401: i18n.t('You are not authorized to create agent deployment.'),
      403: i18n.t('You are not allowed to create agent deployment.'),
      404: i18n.t('The agent deployment you are trying to create does not exist.'),
      500: i18n.t('An error occurred creating the agent deployment.'),
      default: i18n.t('An error occurred creating the agent deployment.')
    },
    SUCCESS: {
      200: i18n.t('Agent deployment created successfully.')
    }
  },
  UPDATE_BOT_DEPLOYMENT: {
    ERROR: {
      401: i18n.t('You are not authorized to update agent deployment.'),
      403: i18n.t('You are not allowed to update agent deployment.'),
      404: i18n.t('The agent deployment you are trying to update does not exist.'),
      500: i18n.t('An error occurred updating the agent deployment.'),
      default: i18n.t('An error occurred updating the agent deployment.')
    },
    SUCCESS: {
      200: i18n.t('Agent deployment updated successfully.')
    }
  },
  DELETE_BOT_DEPLOYMENT: {
    ERROR: {
      401: i18n.t('You are not authorized to delete agent deployment.'),
      403: i18n.t('You are not allowed to delete agent deployment.'),
      404: i18n.t('The agent deployment you are trying to delete does not exist.'),
      500: i18n.t('An error occurred deleting the agent deployment.'),
      default: i18n.t('An error occurred deleting the agent deployment.')
    },
    SUCCESS: {
      200: i18n.t('Agent deployment deleted successfully.')
    }
  },
  CLONE_BOT_DEPLOYMENT: {
    ERROR: {
      401: i18n.t('You are not authorized to clone agent deployment.'),
      403: i18n.t('You are not allowed to clone agent deployment.'),
      404: i18n.t('The agent deployment you are trying to clone does not exist.'),
      500: i18n.t('An error occurred cloning the agent deployment.'),
      default: i18n.t('An error occurred cloning the agent deployment.')
    },
    SUCCESS: {
      200: i18n.t('Agent deployment cloned successfully.')
    }
  },
  DELETE_BOT_DEPLOYMENTS: {
    ERROR: {
      401: i18n.t('You are not authorized to delete agent deployments.'),
      403: i18n.t('You are not allowed to delete agent deployments.'),
      404: i18n.t('The agent deployments you are trying to delete do not exist.'),
      500: i18n.t('An error occurred deleting the agent deployments.'),
      default: i18n.t('An error occurred deleting the agent deployment.')
    },
    SUCCESS: {
      200: i18n.t('Agent deployments deleted successfully.')
    }
  }
};
